import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Container,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalHeader,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrumbs from "../../../../Components/Common/BreadCrumbs";
import CICServices from "../../../../services/COOPServices/CICServices";
import DateFormatter from "../../../../Components/Common/DateFromatter";
const DefaultersDetails = () => {
  const { id } = useParams();
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const breadcrumbItems = [
    { title: "CIC", link: "/cic" },
    { title: " CIC Detail" },
  ];

  console.log("🚀 ~ ReportPage ~ id:", id);
  const fetchData = async () => {
    try {
      const fetchedData = await CICServices.getById(id);
      console.log("🚀 ~ fetchData ~ fetchedData:", fetchedData);
      setData(fetchedData);
    } catch (err) {
      console.error(err);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <Container fluid className="mt-5">
      <div className="page-content">
        <Breadcrumbs items={breadcrumbItems} />
        <Row className="justify-content-center">
          <Col xs={5}>
            <Row className="mb-3">
              <Col xs={12} className="text-end">
                <h2
                  className="cursor-pointer"
                  onClick={() => {
                    navigate("/cic");
                  }}
                >
                  <i className="bx bx-x"></i>
                </h2>
              </Col>
              <Col xs={12} className="text-center">
                <h4 className="card-title mb-0">Individual Details</h4>
              </Col>
            </Row>
            <Card style={{ borderRadius: "20px", backgroundColor: "#f9f9ff" }}>
              <CardBody>
                <Col xs={12} className="text-center">
                  <Row className="mt-4 bg-light py-2">
                    <Col xs={12} className="text-start">
                      <span className="fw-bold px-3">Personal details</span>
                    </Col>
                  </Row>

                  <Row className="mt-4 ps-4">
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Full Name
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.name}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Address
                      </Col>
                      <Col xs={6} className="text-start bg-white mb-1 py-1">
                        {data.address}
                      </Col>
                    </Row>{" "}
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Citizenship number
                      </Col>
                      <Col xs={6} className="text-start py-1 mb-1 bg-white">
                        {data.citizenshipNumber}
                      </Col>
                    </Row>{" "}
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Citizenship issuer district
                      </Col>
                      <Col xs={6} className="text-start mb-1 bg-white py-1">
                        {data.citizenshipIssueDistrict}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Spouse full name
                      </Col>
                      <Col xs={6} className="text-start mb-1 bg-white py-1">
                        {data.spouseFullName}
                      </Col>
                    </Row>
                  </Row>

                  <Row className="mt-4 bg-light py-2">
                    <Col xs={12} className="text-start">
                      <span className="fw-bold px-3">
                        Three generations details
                      </span>
                    </Col>
                  </Row>

                  <Row className="mt-4 ps-4">
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Father full name
                      </Col>
                      <Col xs={6} className="text-start py-1 mb-1 bg-white">
                        {data.fathersFullName}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Grandfather full name
                      </Col>
                      <Col xs={6} className="text-start py-1 mb-1 bg-white">
                        {data.grandfatherFullName}
                      </Col>
                    </Row>{" "}
                  </Row>
                  <Row className="mt-4 bg-light py-2">
                    <Col xs={12} className="text-start">
                      <span className="fw-bold px-3">Loan details</span>
                    </Col>
                  </Row>

                  <Row className="mt-4 ps-4">
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Loan Amount
                      </Col>
                      <Col xs={6} className="text-start py-1 mb-1 bg-white">
                        {data.loanAmount}
                      </Col>
                    </Row>
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Loan maturity date
                      </Col>
                      <Col xs={6} className="text-start py-1 mb-1 bg-white">
                        <DateFormatter dateString={data.loanMaturityDate} />
                      </Col>
                    </Row>{" "}
                    <Row>
                      <Col
                        xs={6}
                        className="text-start py-2 bg-light mb-1 text-muted"
                      >
                        Reporting on basis of
                      </Col>
                      <Col xs={6} className="text-start py-1 mb-1 bg-white ">
                        {data.reportingBasis}
                      </Col>
                    </Row>{" "}
                    {/* <Row>
                      <Col xs={12} className="text-start mt-3 mb-1">
                        <span className="mb-1 mt-2 fw-bold">
                          Remove from List
                        </span>
                      </Col>
                      <Col xs={4}>
                        <FormGroup check>
                          <Input name="radio2" type="radio" />{" "}
                          <Label check>Maker</Label>
                        </FormGroup>
                      </Col>
                      <Col xs={4}>
                        <FormGroup check>
                          <Input name="radio2" type="radio" checked />{" "}
                          <Label check>Checker</Label>
                        </FormGroup>
                      </Col>
                    </Row> */}
                  </Row>
                </Col>
              </CardBody>

              <Row>
                <Col lg={4}></Col>
                <Col lg={4} className="text-end mb-3">
                  <Button
                    className="w-100 bg-warning border-white"
                    onClick={() => {
                      navigate("/cic");
                    }}
                  >
                    Back
                  </Button>
                </Col>
                {/* <Col xs={6} className="text-start">
                    <Button
                      className="w-100 bg-success border-white"
                      onClick={() => {
                        navigate("/cic");
                      }}
                    >
                      {" "}
                      Save
                    </Button>
                  </Col> */}
              </Row>
            </Card>
          </Col>
        </Row>
      </div>
    </Container>
  );
};

export default DefaultersDetails;
